import button from './buttons';
import components from './components';
import constants from './constants';
import JbcFront from './jbc-front';
import reducers from './reducers';
import utils from './utils';
import features from './features';

export default { ...button, ...components, ...constants, ...features, ...JbcFront, ...reducers, ...utils };
